const OfferSpendByOfferDetailsTableLangKey = [
	'column_id',
	'column_date',
	'column_amount',
	'column_account',
	'column_kt_group',
	'column_notes',
] as const

type IOfferSpendByOfferDetailsTableLangKey = typeof OfferSpendByOfferDetailsTableLangKey[number]

export type IOfferSpendByOfferDetailsTableLang = {
	offer_spend_by_offer_details_table: Record<IOfferSpendByOfferDetailsTableLangKey, string>
}

const langEntries = OfferSpendByOfferDetailsTableLangKey.map(
	(key: IOfferSpendByOfferDetailsTableLangKey) => [key, `offer_spend_by_offer_details_table.${key}`]
)

const langObj: Record<IOfferSpendByOfferDetailsTableLangKey, string> = Object.fromEntries(langEntries)

export const OFFER_SPEND_BY_OFFER_DETAILS_TABLE_LANG_KEY: IOfferSpendByOfferDetailsTableLang = {
	offer_spend_by_offer_details_table: langObj
}
